/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function CustomMetadataController() {

    var self = this;

    self.isTextExpression = function (partnerMetadataItem) {
        if (partnerMetadataItem) {
            return partnerMetadataItem.hasOwnProperty('expression');
        }
    };

    self.generateComponentId = function (componentName, uiControlHint, isExpression) {
        var componentId = componentName + uiControlHint;
        if (!!self.main) {
            componentId += self.main;
        } else if (!!self.seasonVolume) {
            componentId += self.seasonVolume.name;
        }
        if (isExpression) {
            componentId += 'Expression';
        }
        return componentId.replace(/\s/g, '');
    };

}

angular.module('prism-ui.components').component('customMetadataComponent', {
    templateUrl: 'components/modal/subscription-properties-modal/custom-metadata-template.html',
    controller: CustomMetadataController,
    bindings: {
        main: '<',
        seasonVolume: '<',
        metadata: '<',
        batchUpdateEnabled: '<',
        partnerMeta: '<'
    }
});
